module.exports = __webpack_public_path__ + "static/media/microscope-01.9080a2b1.PNG";